/* eslint-disable indent */
import PubSub from 'pubsub-js';
import React, { useState, useEffect, useCallback } from 'react';

import { Button, Drawer, Grid, IconButton, Link } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import styleDrawer from '../../themes/drawer';

const useStyles = styleDrawer;

interface IDrawerNativeProps {
  title: string;
  open: boolean;
  onCloseDrawer?: any;
  labelButtonAction?: string | JSX.Element;
  iconButtonAction?: string;
  submitButtonLabel?: string;
  headerButton?: string;
  showBtn?: boolean;
  showBtn2?: boolean;
  disabled?: boolean;
  width?: string | number;
}

const DrawerNative: React.FC<IDrawerNativeProps> = ({
  children,
  iconButtonAction,
  labelButtonAction,
  title,
  submitButtonLabel,
  headerButton,
  showBtn,
  showBtn2,
  disabled,
  open,
  onCloseDrawer,
  width = '30%',
}) => {
  const classes = useStyles();

  const [state, setState] = useState({ right: false });
  const [drawerOpened, setDrawerOpened] = useState(false);
  const [drawerWidth] = useState(width);

  const toggleDrawer = (side: 'right', open: boolean) => (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>,
  ) => {
    if (event.type === 'keydown' && (event.shiftKey || event.altKey)) {
      return;
    }
    setState((state) => ({ ...state, [side]: open }));
  };

  const closeDrawer = useCallback(() => {
    setState({ ...state, right: false });
    // eslint-disable-next-line no-unused-expressions
    onCloseDrawer?.();
    PubSub.unsubscribe('CLOSE-DRAWER');
  }, [onCloseDrawer, state]);

  useEffect(() => {
    if (drawerOpened !== open) {
      setState((state) => ({ ...state, right: open }));
      setDrawerOpened(open);
    }
  }, [open, drawerOpened, state]);

  useEffect(() => {
    if (state.right) {
      PubSub.subscribe('CLOSE-DRAWER', closeDrawer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const ButtonHeadDefault = () => {
    return headerButton !== 'off' ? (
      <Button
        color="primary"
        variant="contained"
        fullWidth
        form="myForm"
        type="submit"
        onClick={() => {
          setTimeout(() => {
            setState({ ...state, right: false });
          }, 3000);
        }}
      >
        {submitButtonLabel || 'SAVE'}
      </Button>
    ) : (
      <></>
    );
  };

  const ButtonHeadSecondary = () => {
    return headerButton !== 'off' ? (
      <Button
        color="primary"
        variant="contained"
        fullWidth
        form="myForm2"
        type="submit"
        onClick={() => {
          setTimeout(() => {
            setState({ ...state, right: false });
          }, 3000);
        }}
      >
        {submitButtonLabel || 'SAVE'}
      </Button>
    ) : (
      <></>
    );
  };

  const DrawerHeader = () => {
    return (
      <>
        <div className={classes.drawerHead}>
          <Grid container spacing={0}>
            <Grid item xs={9}>
              <h2>
                <IconButton onClick={closeDrawer} style={{ padding: 6 }}>
                  <CloseIcon />
                </IconButton>
                {title}
              </h2>
            </Grid>
            <Grid item xs={3}>
              {showBtn ? <ButtonHeadDefault /> : ''}
              {showBtn2 ? <ButtonHeadSecondary /> : ''}
            </Grid>
          </Grid>
        </div>
      </>
    );
  };

  const IconButtonT = () => {
    return (
      <IconButton onClick={toggleDrawer('right', true)}>
        {iconButtonAction}
      </IconButton>
    );
  };

  const LabelButton = () => {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link onClick={toggleDrawer('right', true)}>{labelButtonAction}</Link>
    );
  };

  const ActionButtonAdd = () => {
    return (
      <Button
        variant="outlined"
        color="primary"
        disabled={disabled}
        fullWidth
        onClick={toggleDrawer('right', true)}
      >
        {labelButtonAction}
      </Button>
    );
  };

  return (
    <>
      {iconButtonAction ? (
        <IconButtonT />
      ) : ['Add', 'Import', 'Replicator'].includes(
          labelButtonAction as string,
        ) ? (
        // eslint-disable-next-line react/jsx-indent
        <ActionButtonAdd />
      ) : (
        <LabelButton />
      )}
      <Drawer
        className="placement"
        anchor="right"
        open={state.right}
        onClose={closeDrawer}
        PaperProps={{ style: { width: drawerWidth } }}
      >
        <div role="presentation">
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <DrawerHeader />
              <div className={classes.drawerBody}>{children}</div>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    </>
  );
};

export default DrawerNative;
